import { Injectable, ViewContainerRef } from '@angular/core';
import { Modal, BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { DisplayModalComponent } from './display-modal.component';
import { overlayConfigFactory } from 'ngx-modialog';

@Injectable()
export class DisplayModalService {
    constructor(public modal: Modal) {}

    openDialog(strHtml: string, viewContainer:ViewContainerRef) {
    	(this.modal.overlay as any).defaultViewContainer = viewContainer;
        return this.modal.open(DisplayModalComponent, overlayConfigFactory({strHtml: strHtml}, BSModalContext));
    };
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/display-modal/display-modal.service.ts